import { application } from "./application"

import AutoRefreshController from "./auto_refresh_controller"
import BulkSelectController from "./bulk_select_controller"
import CalculatorController from "./calculator_controller"
import ChartController from "./chart_controller"
import ClockController from "./clock_controller"
import HelloController from "./hello_controller"
import ImageUploadController from "./image_upload_controller"
import InputSpinController from "./input_spin_controller"
import KitchenDisplayController from "./kitchen_display_controller"
import MenuFilterController from "./menu_filter_controller"
import NestedFormController from "./nested_form_controller"
import OrderPaymentController from "./order_payment_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import PermissionMatrixController from "./permission_matrix_controller"
import PosController from "./pos_controller"
import PrintController from "./print_controller"
import QuotePricingController from "./quote_pricing_controller"
import ReceiptPrintController from "./receipt_print_controller"
import SidebarController from "./sidebar_controller"
import TopbarController from "./topbar_controller"
import VirtualSelectController from "./virtual_select_controller"

application.register("auto-refresh", AutoRefreshController)
application.register("bulk-select", BulkSelectController)
application.register("calculator", CalculatorController)
application.register("chart", ChartController)
application.register("clock", ClockController)
application.register("hello", HelloController)
application.register("image-upload", ImageUploadController)
application.register("input-spin", InputSpinController)
application.register("kitchen-display", KitchenDisplayController)
application.register("menu-filter", MenuFilterController)
application.register("nested-form", NestedFormController)
application.register("order-payment", OrderPaymentController)
application.register("password-visibility", PasswordVisibilityController)
application.register("permission-matrix", PermissionMatrixController)
application.register("pos", PosController)
application.register("print", PrintController)
application.register("quote-pricing", QuotePricingController)
application.register("receipt-print", ReceiptPrintController)
application.register("sidebar", SidebarController)
application.register("topbar", TopbarController)
application.register("virtual-select", VirtualSelectController)
